var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBonhommeBatiment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo_horizontal",
    width: 282.169,
    height: 62.473,
    viewBox: "0 0 282.169 62.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(75.917 15.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M-293.843-370.873a3.8,3.8,0,0,0,1.107-2.8v-1.581c0-2.023-1.034-4.437-5.961-4.437h-14.6v18.6h14.65c5.335,0,6.132-2.78,6.132-4.437v-2.506A3.332,3.332,0,0,0-293.843-370.873Zm-3.581-2.431c0,.362,0,.6-1.274.6h-9.914v-2.976h9.914c1.274,0,1.274.239,1.274.6Zm-11.188,4.607h9.962c1.444,0,1.444.505,1.444.721v1.849c0,.588-.106,1.038-1.444,1.038h-9.962Z",
    transform: "translate(313.3 379.687)",
    fill: "#23292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M-247.776-379.687H-259.03c-5.293,0-6.083,3.054-6.083,4.875v8.854c0,1.821.791,4.875,6.083,4.875h11.254c5.292,0,6.082-3.054,6.082-4.875v-8.854C-241.693-376.633-242.484-379.687-247.776-379.687Zm-12.649,4.849c0-.294,0-.842,1.4-.842h11.254c1.394,0,1.394.548,1.394.842v8.905c0,.294,0,.843-1.394.843H-259.03c-1.4,0-1.4-.548-1.4-.843Z",
    transform: "translate(288.449 379.687)",
    fill: "#23292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M-191.495-367.7l-15.987-11.991h-3.762v18.6h4.277V-373.7l17.2,12.618h2.548v-18.6h-4.277Z",
    transform: "translate(260.667 379.687)",
    fill: "#23292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M-138.717-372.875h-12.47v-6.812h-4.688v18.6h4.688v-7.785h12.47v7.785h4.688v-18.6h-4.688Z",
    transform: "translate(232.112 379.687)",
    fill: "#23292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M-87.914-379.687H-99.168c-5.294,0-6.083,3.054-6.083,4.875v8.854c0,1.821.79,4.875,6.083,4.875h11.254c5.291,0,6.082-3.054,6.082-4.875v-8.854C-81.832-376.633-82.623-379.687-87.914-379.687Zm-12.649,4.849c0-.294,0-.842,1.4-.842h11.254c1.393,0,1.393.548,1.393.842v8.905c0,.294,0,.843-1.393.843H-99.168c-1.4,0-1.4-.548-1.4-.843Z",
    transform: "translate(206.004 379.687)",
    fill: "#23292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M-37.532-366.217l-9.739-13.47h-4.11v18.6h4.446v-10.443l7.579,10.443h3.385l7.555-10.459v10.459h4.448v-18.6h-3.869Z",
    transform: "translate(178.222 379.687)",
    fill: "#23292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M24.851-366.217l-9.741-13.47H11v18.6h4.446v-10.444l7.581,10.444h3.385l7.555-10.459v10.459h4.446v-18.6H34.543Z",
    transform: "translate(146.051 379.687)",
    fill: "#23292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M92.372-375.68v-4.007H73.38v18.6H92.372v-4.007h-14.3v-3.778H91.647v-4.007H78.069v-2.805Z",
    transform: "translate(113.88 379.687)",
    fill: "#23292a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(161.306 39.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M-136.977-306.641v-14.971h8.886c3.5,0,5.265.6,5.265,3.892,0,1.717-.381,2.875-2.549,3.314v.08c2.5.24,2.978,1.616,2.978,3.513,0,3.313-1.62,4.172-5.384,4.172Zm3.431-8.7h4.931c1.93,0,2.359-.5,2.359-2.1s-.762-1.717-2.454-1.717h-4.836Zm0,6.247h4.694c2.048,0,3.025-.12,3.025-1.956,0-1.637-.429-2.116-2.454-2.116h-5.265Z",
    transform: "translate(136.977 325.943)",
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_28",
    "data-name": "Trac\\xE9 28",
    d: "M-100.928-314.041l-1.12,2.834h-3.55l5.932-14.971h5.051l6.051,14.971h-3.479l-1.167-2.834Zm8.1-14.311-.6,1-3.645-1.258-3.669,1.258-.572-1,4.241-2.156Zm-4.217,4.371h-.047l-3.049,7.764h6.17Z",
    transform: "translate(120.794 330.509)",
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M-65.743-306.641h-3.431v-12.515h-5.241v-2.456H-60.5v2.456h-5.241Z",
    transform: "translate(104.712 325.943)",
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M-39.221-306.641h-3.431v-14.971h3.431Z",
    transform: "translate(88.331 325.943)",
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_31",
    "data-name": "Trac\\xE9 31",
    d: "M-18.791-306.641h-3.074l-5.67-12.555h-.071l.286,12.555h-3.431v-14.971h5.5l4.86,11.118h.1l4.764-11.118h5.622v14.971h-3.431l.286-12.615h-.119Z",
    transform: "translate(82.194 325.943)",
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M20.458-315.424H28.82v2.355H20.458v3.972h8.886v2.455H17.027v-14.971H29.272v2.456H20.458Z",
    transform: "translate(57.553 325.943)",
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M59.663-321.612h3.431v14.971H57.4l-7.6-12.515h-.119l.286,12.515H46.536v-14.971h5.67L59.854-309.1h.1Z",
    transform: "translate(42.335 325.943)",
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M92.487-306.641H89.056v-12.515H83.815v-2.456H97.728v2.456H92.487Z",
    transform: "translate(23.109 325.943)",
    fill: "#002581"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 62.145,
    height: 62.473,
    fill: "#002581"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 8.815,
    height: 8.861,
    transform: "translate(26.665 32.708)",
    fill: "#f58836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M-428.849-385.179v7.3h14.514V-356h-21.77v-40.984h-7.257V-348.7h36.284v-36.475Z",
    transform: "translate(456.293 404.079)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBonhommeBatiment);
export default __webpack_public_path__ + "static/media/logo-Bonhomme-Batiment.166dbef30c67f66024129be2750bd667.svg";
export { ForwardRef as ReactComponent };